import React, { useState, useEffect } from "react";
import { CheckCircle, AlertCircle, X } from "lucide-react";

// Toast notification component for displaying success/error messages
const Toast = ({ message, type, onClose, autoClose = true }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onClose, 300); // Allow animation to complete before removing
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [autoClose, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  // Styles for the toast
  const baseStyle = {
    position: "fixed",
    bottom: "24px",
    right: "24px",
    padding: "12px 16px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    maxWidth: "400px",
    zIndex: 9999,
    transform: isVisible ? "translateY(0)" : "translateY(100%)",
    opacity: isVisible ? 1 : 0,
    transition: "all 0.3s ease-in-out",
  };

  const types = {
    success: {
      backgroundColor: "#dcfce7",
      color: "#16a34a",
      borderLeft: "4px solid #22c55e",
    },
    error: {
      backgroundColor: "#fee2e2",
      color: "#dc2626",
      borderLeft: "4px solid #ef4444",
    },
    info: {
      backgroundColor: "#e0f2fe",
      color: "#0284c7",
      borderLeft: "4px solid #38bdf8",
    },
  };

  return (
    <div style={{ ...baseStyle, ...types[type] }}>
      {type === "success" ? (
        <CheckCircle size={20} />
      ) : (
        <AlertCircle size={20} />
      )}
      <div style={{ flex: 1 }}>{message}</div>
      <button
        onClick={handleClose}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "inherit",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "4px",
        }}
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default Toast;
